// extracted by mini-css-extract-plugin
export default {"root":"EstablishmentsLoadError_root__4Ftgu","icon":"EstablishmentsLoadError_icon__tfjaV"};